// ** React Imports
import { useContext } from 'react'

// ** Component Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

const CanViewNavSectionTitle = props => {
  // ** Props
  const { children, navTitle } = props

  // ** Hook
  const ability = useContext(AbilityContext)

  // During migration: if no ACL meta is provided, don't block rendering.
  if (!navTitle?.action || !navTitle?.subject) {
    return <>{children}</>
  }

  return ability && ability.can(navTitle.action, navTitle.subject) ? <>{children}</> : null
}

export default CanViewNavSectionTitle
